<!-- src/views/About.vue -->
<template>
  <div class="content">
    <div class="container-fluid">
      <div class="card">
        <div class="card-header">
           <h4 class="card-title">About</h4>
        </div>
        <div class="card-body">
           <p>Learn more about us on this page.</p>

           <b-button variant="primary" class="mb-3 btn-fill" @click="callToast">Toast</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

  
  
  <script>
  export default {
    name: 'About-Page',
    methods:{
      callToast(){
        // this.$toast("I'm a toast!");

        // Or with options
        this.$toast("Record Updated", {
            timeout: 2000,
            type:"success",
            position: "top-center",
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: "button",
            icon: true,
            rtl: false
        });
        // These options will override the options defined in the "Vue.use" plugin registration for this specific toast
              }
    }

  };
  </script>
  